module.exports = __webpack_public_path__ + "img/ontimer-demo.ea40da6d.png";